module.exports = __webpack_public_path__ + "img/scatter-chart-svgrepo-com-orange.0ab2632d.svg";